module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-1600x2-2604859bd045c297c9aece5c3f4462a5.jpg";